module.exports = "./img/65de5c6e3b10058497d06328e91b1d75.png";